import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-66400b13"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "role-table" }
const _hoisted_2 = { class: "operate" }
const _hoisted_3 = { class: "table" }
const _hoisted_4 = { class: "op" }
const _hoisted_5 = ["onClick"]
const _hoisted_6 = ["onClick"]
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "icon-delete" }, null, -1))
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("button", null, "删除", -1))

import {
  ref, unref, reactive, computed, watch,provide,
} from 'vue';
import { useStore, } from 'vuex';
import {
  Input, Table, ConfigProvider, message, Popconfirm,
} from 'ant-design-vue';
import zhCN from 'ant-design-vue/es/locale/zh_CN';

import { ColumnProps, } from 'ant-design-vue/es/table/interface';
import CreateModal from '../../../../components/newModal/index.vue';
import RightModal from '../rightConfig/index.vue';
import RoleInfo from '../roleInfo/index.vue';
import { randomString, } from '@/utils/index';

type Key = ColumnProps['key'];

type ColumnType = {
  title: string;
  dataIndex?: string;
  slots?: any;
  width?: any;
  ellipsis?: boolean;
};

// 列表行配置

export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const store = useStore();

const { Search, } = Input;

const columns: ColumnType[] = [
  {
    title: '序号',
    slots: { customRender: 'index', },
    width: '8%',
  },
  {
    title: '角色名称',
    dataIndex: 'roleName',
    width: '12%',
    ellipsis: true,
  },
  {
    title: '备注',
    dataIndex: 'roleDesc',
    width: '30%',
    ellipsis: true,
  },
  {
    title: '创建人',
    dataIndex: 'creator',
    width: '12%',
    ellipsis: true,
  },
  {
    title: '创建时间',
    dataIndex: 'createTime',
    width: '15%',
    ellipsis: true,
  },
  {
    title: '操作',
    slots: { customRender: 'op', },
    width: '18%',
  },
];
// 表格数据
const tableData = ref<any>([]);
// 当前页面
const current = ref<number>(1);
// 数据总数
const total = ref<number>(0);
// 选中的id
const selectedKeys = ref<any[]>([]);
// 选中的row
const selectedRow = ref<Key[]>([]);
// 角色对应的人员
const roleUser = ref({});

const itemInfo = ref<any>({});

provide(
  'itemInfo',
  computed(() => itemInfo.value)
);

/**
 * 加载表格数据
 * @param {*} pageNo 当前页码
 * @param {*} searchValue 查询字符
 * @return {void}
 */
const loadTable = (pageNo = 1, searchValue = ''): void => {
  const params = searchValue ?
    {
      searchValue,
      pageNo,
      pageSize: 10,
    } :
    {
      pageNo,
      pageSize: 10,
    };

  store.dispatch('userCenter/getRoleList', params);
};

// 加载全部数据
loadTable();

// 列表数据
const roleList = computed(() => store.state.userCenter.roleList);

watch(roleList, (val) => {
  tableData.value = val?.list || [];
  total.value = val?.total || 0;
  selectedKeys.value = [];
  selectedRow.value = [];
},{
  deep: true,
});

// 搜索内容
const searchValue = ref<string>('');

/**
 * @method onSearch
 * @return {void} 搜索
 */
const onSearch = ():void => {
  current.value = 1;
  loadTable(current.value , searchValue.value);
};
// 新建弹窗显隐
const modalVisible = ref<boolean>(false);
// 权限配置显隐
const rightVisible = ref<boolean>(false);
// 当前角色
const currentRole = ref<any>({});
// 角色类型
const roleType = ref<string>('');
// 角色id
const roleId = ref<string>('');
// 角色权限
const roleRight = ref<any[]>([]);
// 角色数据
const roleDataType = ref<string>('');
// 角色用户信息显隐
const infoVisible = ref<boolean>(false);

/**
 * @method handleChange
 * @param {any[]} page 传入当前点击的页码
 * @param {any[]} pageSize 传入当前点击的页数
 * @return {void}
 */
const handleChange = (page: any, pageSize: any) => {
  current.value = page;
  loadTable(page);
};

const rowSelection = computed(() => ({
  selectedRowKeys: unref(selectedRow),
  onChange: (selectedRowKeys: Key[], selectedRows: any[]) => {
    selectedRow.value = selectedRowKeys;
    selectedKeys.value = [];
    // 获取选中的ids
    selectedRows.forEach((item: any) => {
      selectedKeys.value.push(item.id);
    });
  },
}));

/**
 * @method handleNew
 * @return {void} 新建
 */
const handleNew = (): void => {
  modalVisible.value = true;
};

/**
 * @method handleDeleteAll
 * @return {void} 批量删除
 */
const handleDeleteAll = (): void => {
  if (selectedKeys.value.length) {
    // 调取接口删除
    store.dispatch('userCenter/deleteRoleAll', selectedKeys.value).then(() => {
      loadTable(current.value , searchValue.value);
    });
  } else {
    message.warn('请至少选择一条数据');
  }
};

/**
 * @method showRightConfig
 * @param {any} role 选择的角色
 * @return {void} 权限配置
 */
const showRightConfig = (role: any): void => {
  itemInfo.value = role || {};
  // 获取数据类型
  store.dispatch('userCenter/getDataType', role.id).then((data) => {
    roleDataType.value = data.dataType;
    roleType.value = role.roleName;
    roleId.value = role.id;
    roleRight.value = role.menuIds;
    // 获取权限
    store.dispatch('userCenter/getGrant').then(() => {
      rightVisible.value = true;
    });
  });
};

/**
 * @method showRole
 * @param {any} role 选择的角色
 * @return {void} 查看人员
 */
const showRole = (role: any): void => {
  currentRole.value = role;
  const params = {
    roleId: role.id,
    pageNo: 1,
    pageSize: 10,
  };

  store.dispatch('userCenter/getSelectRoleInfo', params).then((res) => {
    infoVisible.value = true;
    roleUser.value = res;
  });
};

const handleSizeChange = ({ pageSize, pageNum, }: { pageSize: number, pageNum: number, }) => {
  store.dispatch('userCenter/getSelectRoleInfo', {
    roleId: currentRole.value.id,
    pageNo: pageNum,
    pageSize,
  }).then((res) => {
    infoVisible.value = true;
    roleUser.value = res;
  });
};

/**
 * @method deleteConfirm
 * @param {any} item 删除的数据
 * @return {void} 单个删除
 */
const deleteConfirm = (item:any): void => {
  const { id, } = item;

  // 调取接口删除
  store.dispatch('userCenter/deleteRoleAll', [id,]).then(() => {
    loadTable(current.value , searchValue.value);
  });
};

/**
 * @method save
 * @param {any} info emit的参数
 * @param {string} type 类型
 * @return {void} 新建保存
 */
const save = (info: any, type:string): void => {
  /* eslint-disable */
  if (type === 'new') {
    const { roleName, note, } = info;
    const param = {
      roleName,
      roleDesc: note,
      roleCode: randomString(6),
      // 默认权限列表
      menuIds:[],
    };

    store.dispatch('userCenter/createRole', param).then(() => {
      loadTable(current.value , searchValue.value);
      modalVisible.value = false;
    });
  } else if (type === 'right') {
    rightVisible.value = false;
    // 加载全部数据
    loadTable();
  } else if (type === 'role') {
    infoVisible.value = false;
  }
};

/**
 * @method cancal
 * @param {string} type 类型
 * @return {void}
 */
const cancal = (type:string): void => {
  if (type === 'new') {
    modalVisible.value = false;
  } else if (type === 'right') {
    rightVisible.value = false;
  } else if (type === 'role') {
    infoVisible.value = false;
  }
};


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_unref(Search), {
        value: searchValue.value,
        "onUpdate:value": _cache[0] || (_cache[0] = ($event: any) => ((searchValue).value = $event)),
        placeholder: "请输入角色名称",
        style: {"width":"3rem","height":"0.32rem","border-radius":"0.04rem"},
        onSearch: onSearch
      }, null, 8, ["value"]),
      _createElementVNode("div", { class: "operate-button" }, [
        _createElementVNode("button", {
          class: "btn new",
          onClick: handleNew
        }, "新建"),
        _createElementVNode("button", {
          class: "btn del",
          onClick: handleDeleteAll
        }, "批量删除")
      ])
    ]),
    _createElementVNode("div", _hoisted_3, [
      _createVNode(_unref(ConfigProvider), { locale: _unref(zhCN) }, {
        default: _withCtx(() => [
          _createVNode(_unref(Table), {
            columns: columns,
            scroll: {
            y: '5.6rem'
          },
            pagination: {
            total:total.value,
            pageSize:10,
            size:'small',
            current:current.value,
            showQuickJumper: true,
            showTotal: (total) => `共 ${total} 条`,
            onChange: (page, pageSize) => handleChange(page, pageSize),
          },
            "data-source": tableData.value,
            "row-selection": _unref(rowSelection),
            rowKey: (record) => record.id
          }, {
            index: _withCtx(({ index,}) => [
              _createElementVNode("span", null, _toDisplayString(index + 1), 1)
            ]),
            op: _withCtx(({ text, }) => [
              _createElementVNode("div", _hoisted_4, [
                _createElementVNode("button", {
                  onClick: ($event: any) => (showRightConfig(text))
                }, "权限配置", 8, _hoisted_5),
                _createElementVNode("button", {
                  onClick: ($event: any) => (showRole(text))
                }, "查看人员", 8, _hoisted_6),
                _createVNode(_unref(Popconfirm), {
                  overlayClassName: "delete-pop",
                  title: "是否删除?",
                  "ok-text": "确定",
                  "cancel-text": "取消",
                  onConfirm: ($event: any) => (deleteConfirm(text))
                }, {
                  icon: _withCtx(() => [
                    _hoisted_7
                  ]),
                  default: _withCtx(() => [
                    _hoisted_8
                  ]),
                  _: 2
                }, 1032, ["onConfirm"])
              ])
            ]),
            _: 1
          }, 8, ["scroll", "pagination", "data-source", "row-selection", "rowKey"])
        ]),
        _: 1
      }, 8, ["locale"])
    ]),
    _createVNode(CreateModal, {
      type: "role",
      "create-visible": modalVisible.value,
      onCancal: _cache[1] || (_cache[1] = ($event: any) => (cancal('new'))),
      onSave: _cache[2] || (_cache[2] = ($event: any) => (save($event, 'new')))
    }, null, 8, ["create-visible"]),
    _createVNode(RightModal, {
      "right-visible": rightVisible.value,
      "role-type": roleType.value,
      "role-id": roleId.value,
      "role-right": roleRight.value,
      "role-data": roleDataType.value,
      onRightCancal: _cache[3] || (_cache[3] = ($event: any) => (cancal('right'))),
      onRightSave: _cache[4] || (_cache[4] = ($event: any) => (save($event,'right')))
    }, null, 8, ["right-visible", "role-type", "role-id", "role-right", "role-data"]),
    _createVNode(RoleInfo, {
      "info-visible": infoVisible.value,
      roleUser: roleUser.value,
      onInfoCancal: _cache[5] || (_cache[5] = ($event: any) => (cancal('role'))),
      onInfoConfirm: _cache[6] || (_cache[6] = ($event: any) => (save($event,'role'))),
      onSizeChange: handleSizeChange
    }, null, 8, ["info-visible", "roleUser"])
  ]))
}
}

})